export default __webpack_public_path__ + "static/media/640_dummy2016-deko01-de.77453ae9.png";